import httpRequest from './httpService'
import logger from './loggerService'
import authService from './authService'
// import bool2Num from './bool2Num'
import dictAdapter from './dictAdapter'
import dictFilter from './dictFilter'
import dictService from './dictService'
import operationService from './operationService'
import TaxService from './TaxService'
import billChangeService from './billChangeService'
import startNumFilter from './startNumFilter'
import scanService from './scanService'
import popupSelectFilter from './popupSelectFilter'
import treeSelectService from './treeSelectService'
import querySortService from './querySortService'
import removeSessionService from './removeSessionService'
import hasPDFReader from './hasPDFReader'
import collectionExportService from './collectionExportService'
import messageService from './messageService'
import exportSettingService from './exportSettingService'
import initSortService from './initSortService'
import scrollService from './scrollService'
import getOvatAmtService from './getOvatAmtService'
import resultTipService from './resultTipService'
import modalSelConDetailService from './modalSelConDetailService'
import roleFilter from './roleFilter'
import checkBuyerCreditCode from './checkBuyerCreditCode'
import batchHandle from './batchHandle'
import splitTips from './splitTips'
import getCodeAndNumber from './getCodeAndNumber'
import batchFilterService from './batchFilterService'
import deBounceService from './deBounce'
import composeService from './composeService'
import selectManualSolution from './selectManualSolution'

export default angular
  .module('app.services', [])
  .service('httpRequest', httpRequest)
  .service('logger', logger)
  .service('authService', authService)
  .service('dictService', dictService)
  .filter('dictFilter', dictFilter)
  .filter('dictAdapter', dictAdapter)
  .service('operationService', operationService)
  .service('taxService', TaxService)
  .service('billChangeService', billChangeService)
  .filter('startNumFilter', startNumFilter)
  .service('scanService', scanService)
  .filter('popupSelectFilter', popupSelectFilter)
  .service('treeSelectService', treeSelectService)
  .service('querySort', querySortService)
  .service('removeSessionService', removeSessionService)
  .service('hasPDFReader', hasPDFReader)
  .service('collectionExportService', collectionExportService)
  .service('messageService', messageService)
  .service('exportSettingService', exportSettingService)
  .service('scrollService', scrollService)
  .service('initSortService', initSortService)
  .service('getOvatAmtService', getOvatAmtService)
  .service('resultTipService', resultTipService)
  .service('modalSelConDetailService', modalSelConDetailService)
  .filter('roleFilter', roleFilter)
  .service('buyerChecker', checkBuyerCreditCode)
  .service('batchHandle', batchHandle)
  .service('splitTips', splitTips)
  .service('getCodeAndNumber', getCodeAndNumber)
  .service('batchFilterService', batchFilterService)
  .service('deBounceService', deBounceService)
  .service('composeService', composeService)
  .service('selectManualSolution', selectManualSolution)
  .name



// WEBPACK FOOTER //
// ./src/common/services/index.js